import React, { useState, useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom'
import SidebarMenu from '../sidebar-menu'
import './Header.css'

const dataHeaderField: any = null
export default function Header (props: any) {
  const { webNotification, getDataTopTitle } = props
  const [keyword, setKeyword] = useState('')
  const [showSidebar, setShowSidebar] = useState(false)
  const [dataHeader, setDataHeader] = useState(dataHeaderField)
  const history = useHistory()
  const handleChange = (e: any) => {
    const value = e.target.value
    setKeyword(value)
  }

  useEffect(() => {
    setDataHeader(getDataTopTitle(webNotification, 'TopTitle'))
  }, [webNotification, getDataTopTitle])

  const handleKeydown = (e: any) => {
    if (e.key === 'Enter' && keyword) {
      e.preventDefault()
      history.push(`/search_result?keyword=${keyword}`)
    }
  }

  const onOpenSidebar = () => {
    setShowSidebar(true)
  }

  const onCloseSidebar = () => {
    setShowSidebar(false)
  }

  return (
    <>
      <nav className="navbar navbar-expand-lg fixed-top px-3">
        <Link className="navbar-brand" to="/">
          <img src="/assets/img/logo.png" alt="" />
        </Link>
        <div className="collapse navbar-collapse">
          <form className="form-inline mt-2 mt-md-0 me-3">
            <div className="input-group top-search">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <i className="bi bi-search" />
                </span>
              </div>
              <input
                className="form-control top-input-search"
                type="text"
                placeholder="例：エリア、店名、ジャンル"
                aria-label="Search"
                value={keyword}
                onChange={handleChange}
                onKeyDown={handleKeydown}
              />
              <div className="input-group-append">
                <span className="input-group-text">
                  <img src="/assets/img/search-icon.png" alt="" />
                </span>
              </div>
            </div>
          </form>
          <div className="shop-name">
            <h3>◆ 新規加盟店舗のお知らせ</h3>
            <h4>
              {
                dataHeader && dataHeader.content
              }
              &nbsp;&nbsp;
              {
                dataHeader && dataHeader.notificationLinks && dataHeader.notificationLinks.length > 0
                  ? <Link to={{ pathname: dataHeader.notificationLinks[0].url }} target="_blank">{dataHeader.notificationLinks[0].text}</Link>
                  : ''
              }
            </h4>
          </div>
        </div>
        <button type="button" id="sidebarCollapse" className="btn btn-show-sidebar" onClick={onOpenSidebar}>
          <i className="bi bi-list" />
        </button>
      </nav>
      <SidebarMenu show={showSidebar} onClose={onCloseSidebar} />
    </>
  )
}
